






























































































































































































































































































































































































































































































import { PageModule } from "@/store/module/page";
import {
  getRecycleStudentListData,
  getRecycleStudentListApi,
} from "@/api/studentManage";
import eventBus from "@/utils/bus";
import { deldetails } from "@/api/studyDetails";
import { dateFormat } from "@/utils/timeFormat";
import commonStaffPullDown from "@/components/commonStaffPullDown.vue";
import { Vue, Component } from "vue-property-decorator";
import commonSearchFormWrapper from "@/components/commonSearchFormWrapper.vue";
import {
  getStudentAppearListApi,
  sourceTypeSelectListApi,
} from "@/api/storeManagement";
import recycleDialog from "./recycleDialog.vue";
import commonDateRangeSelector from "@/components/commonDateRangeSelector.vue";

@Component({
  name: "recycleStudent",
  components: {
    commonStaffPullDown,
    commonSearchFormWrapper,
    recycleDialog,
    commonDateRangeSelector,
  },
})
export default class extends Vue {
  dialogVisible = false;
  courseTeacherInfo: any = {
    type: "",
  };
  searchInfo: any = {
    key_word: "",
    recycle_staff_id: "",
    create_date: [],
    recycle_date: [],
    recycle_category_id: "",
    appear_id: "",
    source_type: "",
    allocate_num_start: "",
    allocate_num_end: "",
    follow_time: [],
    sort_type: "desc",
    sort_field: "create_time",
  };
  tableData: any[] = [];
  multipleSelection: any[] = [];
  studentIds: number[] = [];
  page: number = 1;
  pageSize: number = 10;
  pageSizeArray: number[] = [5, 10, 30, 50, 100];
  total: number = 0;
  sourceList: any[] = [];
  studentAppearLabelList: any[] = [];

  created() {
    eventBus.$on("latent-list-update-recycle", () => {
      const table: any = this.$refs["main-table"];
      table.clearSelection();
      this.handleRefresh();
    });
    if (PageModule.latestRoute === "studyDetails") {
      const cache = PageModule.pageInfo.recruitRecycleList;
      if (cache.page) {
        this.page = cache.page;
      }
      if (cache.search_info) {
        this.searchInfo = cache.search_info;
      }
      this.getList({
        page: cache.page,
        page_size: this.pageSize,
      });
    } else {
      this.getList({
        page: 1,
        page_size: this.pageSize,
      });
    }
    getStudentAppearListApi({
      page: 1,
      page_size: 500,
    }).then((res) => {
      this.studentAppearLabelList = res.data.list;
    });
  }
  resetSearch() {
    this.searchInfo = {
      key_word: "",
      recycle_staff_id: "",
      create_date: [],
      recycle_date: [],
      recycle_category_id: "",
      appear_id: "",
      source_type: "",
      allocate_num_start: "",
      allocate_num_end: "",
      follow_time: [],
      sort_type: this.searchInfo.sort_type,
      sort_field: this.searchInfo.sort_field,
    };
    this.handleSearch();
  }
  handleSearch() {
    this.getList({
      page: 1,
      page_size: this.pageSize,
    });
  }
  handleRefresh() {
    this.getList({
      page: this.page,
      page_size: this.pageSize,
    });
  }
  // 删除行后判断是否倒退一页
  handlePrePage(number: number) {
    let page = this.page;
    if (number >= this.tableData.length) {
      page = page - 1;
    }
    this.getList({
      page: page > 0 ? page : 1,
      page_size: this.pageSize,
    });
  }
  getList(params: { page: number; page_size: number }) {
    const option: getRecycleStudentListData = {
      page: params.page,
      page_size: params.page_size,
    };
    if (this.searchInfo.key_word) {
      option.key_word = this.searchInfo.key_word;
    }
    if (this.searchInfo.recycle_staff_id !== "") {
      option.recycle_staff_id = this.searchInfo.recycle_staff_id;
    }
    if (
      this.searchInfo.create_date &&
      this.searchInfo.create_date.length === 2
    ) {
      option.start_time = this.searchInfo.create_date[0].getTime() / 1000;
      option.end_time =
        this.searchInfo.create_date[1].getTime() / 1000 + 24 * 60 * 60 - 1;
    }
    if (
      this.searchInfo.recycle_date &&
      this.searchInfo.recycle_date.length === 2
    ) {
      option.recycle_start_time =
        new Date(this.searchInfo.recycle_date[0] + " 00:00:01").getTime() /
        1000;
      option.recycle_end_time =
        new Date(this.searchInfo.recycle_date[1] + " 23:59:59").getTime() /
        1000;
    }
    if (this.searchInfo.recycle_category_id !== "") {
      option.recycle_category_id = this.searchInfo.recycle_category_id;
    }
    if (this.searchInfo.appear_id !== "") {
      option.appear_id = this.searchInfo.appear_id;
    }
    if (this.searchInfo.source_type !== "") {
      option.source_type = this.searchInfo.source_type;
    }
    if (this.searchInfo.allocate_num_start !== "") {
      option.allocate_num_start = Number(this.searchInfo.allocate_num_start);
    }
    if (this.searchInfo.allocate_num_end !== "") {
      option.allocate_num_end = Number(this.searchInfo.allocate_num_end);
    }
    if (
      this.searchInfo.follow_time &&
      this.searchInfo.follow_time.length === 2
    ) {
      option.follow_start_time = this.searchInfo.follow_time[0];
      option.follow_end_time = this.searchInfo.follow_time[1];
    }
    if (this.searchInfo.sort_type !== "" && this.searchInfo.sort_field !== "") {
      option.sort_type = this.searchInfo.sort_type;
      option.sort_field = this.searchInfo.sort_field;
    }
    getRecycleStudentListApi(option).then((res: any) => {
      this.page = res.data.page;
      this.total = res.data.total;
      res.data.list.map((item: any) => {
        item.create_time = dateFormat("YYYY-mm-dd", item.create_time * 1000);
        item.recycle_time = dateFormat("YYYY-mm-dd", item.recycle_time * 1000);
        item.allocate_time = dateFormat(
          "YYYY-mm-dd",
          item.allocate_time * 1000
        );
        item.follow_time = dateFormat("YYYY-mm-dd", item.follow_time * 1000);
      });
      this.tableData = res.data.list;
      if (res.data.page > 1 && res.data.list.length === 0) {
        this.handleSearch();
      }
    });
  }
  handleSelectionChange(arr: any[]) {
    this.multipleSelection = arr;
  }
  handleRecover(type: string, id?: number) {
    if (type === "single") {
      if (!id) {
        return false;
      }
      this.studentIds = [id];
    } else {
      if (this.multipleSelection.length === 0) {
        return false;
      }
      this.studentIds = [];
      this.multipleSelection.map((item: any) => {
        this.studentIds.push(item.student_id);
      });
    }
    this.courseTeacherInfo.type = type;
    this.dialogVisible = true;
  }
  handleDelete(type: string, row?: any) {
    let ids: number[] = [];
    let names: string[] = [];
    if (type === "single") {
      if (!row) {
        return false;
      }
      ids = [row.student_id];
      names = [row.name];
    } else {
      if (this.multipleSelection.length === 0) {
        return false;
      }
      this.multipleSelection.map((item: any) => {
        ids.push(item.student_id);
        names.push(item.name);
      });
    }
    this.$confirm(
      "删除后，学员基本信息等数据将被清除，此操作不能撤销。",
      `删除 - ${names.join("、")}`,
      {
        confirmButtonText: "确定",
        confirmButtonClass: "mwow-button-filled success mini",
        cancelButtonText: "取消",
        cancelButtonClass: "mwow-button-filled mini",
        iconClass: "mwow-icon-error",
      }
    )
      .then(() => {
        deldetails({ student_ids: ids }).then((res) => {
          if (res.data.check === false) {
            this.$alert(
              `选择学员中已有订单记录，如需删除请废除学员所有订单后，再进行删除。`,
              `无法删除`,
              {
                confirmButtonText: "关闭",
                confirmButtonClass: "mwow-button-filled mini",
                iconClass: "mwow-icon-error",
              }
            );
          } else {
            this.$message({
              type: "success",
              message: "删除成功!",
            });
            this.handlePrePage(
              type === "single" ? 1 : this.multipleSelection.length
            );
          }
        });
      })
      .catch(() => {});
  }
  handleView(id: number) {
    PageModule.SET_PAGE_INFO({
      name: "recruitRecycleList",
      key: "search_info",
      value: { ...this.searchInfo },
    });
    this.$router.push({
      name: "studyDetails",
      query: { id: String(id), tab: "followup" },
    });
  }
  handleSearchSource() {
    if (!this.searchInfo.appear_id) {
      return false;
    }
    sourceTypeSelectListApi({
      appear_id: this.searchInfo.appear_id,
    }).then((res: any) => {
      if (res.error_code === 0) {
        this.sourceList = res.data.list;
      }
    });
  }
  handleAppear(scope: any) {
    let target = this.studentAppearLabelList.find((item: any) => {
      return scope.row.appear_id === item.id;
    });
    if (target) {
      return target.name;
    } else {
      return "-";
    }
  }
  handlePagerChange(e: number) {
    this.getList({
      page: e,
      page_size: this.pageSize,
    });
    PageModule.SET_PAGE_INFO({
      name: "recruitRecycleList",
      key: "page",
      value: e,
    });
  }
  handlePagerSizeChange(e: number) {
    this.pageSize = e;
    this.getList({
      page: 1,
      page_size: e,
    });
  }
  beforeDestroy() {
    eventBus.$off("latent-list-update-recycle");
  }
  toStudentDetail(row: any) {
    this.$router.push({
      name: "studyDetails",
      query: { id: row.student_id, tab: "followup" },
    });
  }
  // 排序
  clickStort(e: { order: string; prop: string }) {
    this.searchInfo.sort_field = e.prop;
    if (e.order == "descending") {
      this.searchInfo.sort_type = "desc";
    } else if (e.order == "ascending") {
      this.searchInfo.sort_type = "asc";
    } else {
      this.searchInfo.sort_type = "";
    }
    this.handleSearch();
  }
}
